export default __webpack_public_path__ + "debf8c7cb0c01ed2f952671ea2ddc2ff.png";